import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class Preservation extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'preservation'}
            title={'PROCEDURE P11.0 PRESERVATION'}
            exportTitle={'<h2>Procedure P11.0 Preservation</h2>'}
            exportFileName={'preservation.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Preservation);
